<template>

	<!-- Page Header -->
	<div class="page-header page-header-light shadow">
		<div class="page-header-content d-lg-flex">
			<div class="d-flex">
				<h4 class="page-title mb-0">
					<router-link href="#" class="mb-xs-1 text-dark cursor-pointer" :to="'Dashboard'"><i class="icon-arrow-left52 me-1"></i></router-link>
					<a href="#" class="hidden-xs text-dark fw-semibold cursor-pointer" v-on:click="getVociPreferite()">Contabilità</a>
					<span class="hidden-xs ms-1">\</span>
					<span class="text-muted ms-1">Voci Preferite</span>
				</h4>
				<a href="#page_header_vp" class="hidden-lg btn btn-light align-self-center collapsed border-transparent rounded-pill p-0 ms-auto" data-bs-toggle="collapse">
					<i class="ph-caret-down collapsible-indicator ph-sm m-1"></i>
				</a>
			</div>
			<div class="collapse d-lg-block my-lg-auto ms-lg-auto text-center" id="page_header_vp">
				<div class="d-sm-flex align-items-center mb-3 mb-lg-0 ms-lg-3">
					<a href="#" class="d-inline-flex align-items-center text-body lh-1 py-sm-2 position-10" style="text-align: left;" v-if="$root.hasFunzionalita('VOCI_PREFERITE_CREATE')" v-on:click="nuovaVocePreferita()">
						<i class="ph-plus fw-bold me-2 btn btn-outline-success w-32px h-32px rounded-pill"></i>
						<div class="me-auto me-lg-1 ms-1">
							<div class="fs-sm text-muted mb-0"><Translate :path="'dizionario.base.BTN_NUOVA'"></Translate> Voce Preferita</div>
							<div class="text-success fw-semibold"><Translate :path="'dizionario.base.BTN_ADD'"></Translate></div>
						</div>
					</a>
					<div class="vr flex-shrink-0 my-2 mx-3"></div>
					<div class="d-inline-flex float-end mt-sm-0">
						<a v-if="$root.hasFunzionalita('CONF_VOCI_PREFERITE_READ')" href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill" v-on:click="$root.confTravelTipologiche(64)" title="Configurazione Voci Preferite" data-bs-toggle="tooltip" data-bs-placement="left"><i class="ph-lightning"></i></a>
						<a href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill ms-2" v-on:click="$root.confTravelLingue(64)" title="Definizioni Lingua" data-bs-toggle="tooltip" data-bs-placement="left"><i class="ph-flag"></i></a>
						<a href="#" class="btn btn-outline-pink btn-icon w-32px h-32px squared-pill ms-2" v-on:click="$root.help(64)" title="Help OnLine" data-bs-toggle="tooltip" data-bs-placement="left"><i class="icon-question7 pink"></i></a>
					</div>
				</div>
			</div>
		</div>

		<div class="navbar navbar-expand-lg border-top py-1">
			<div class="container-fluid">
				<ul class="nav navbar-nav flex-row flex-fill" role="tablist">
					<li class="nav-item me-1" role="presentation">
						<a href="#vocip-tab" class="navbar-nav-link navbar-nav-link-icon navbar-sm active rounded" data-bs-toggle="tab" aria-selected="true" role="tab">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="ph-star"></i>
								<span class="hidden-lg ms-1">Voci Preferite</span>
								<span class="hidden-xs ms-1">Elenco Voci Preferite</span>
							</div>
						</a>
					</li>
				</ul>
				<div class="page-header-content d-lg-flex">
					<div class="d-flex">
						<a href="#page_header_vp_nav" class="hidden-lg btn btn-light align-self-center collapsed border-transparent rounded-pill p-0 ms-auto" data-bs-toggle="collapse">
							<i class="ph-caret-down collapsible-indicator ph-sm m-1"></i>
						</a>
					</div>
					<div id="page_header_vp_nav" class="collapse d-lg-block ms-lg-auto mt-2 mt-lg-0">
						<div class="d-flex gap-2 align-items-center flex-wrap">
							<button class="btn btn-primary btn-sm" @click="getVociPreferite()">
								<i class="ph-arrows-clockwise me-1"></i> AGGIORNA
							</button>
						</div>
					</div>
				</div>
				<div class="navbar-collapse collapse" id="vocip_nav">
					<ul class="navbar-nav ms-lg-auto mt-2 mt-lg-0 select-small">
						<li class="nav-item dropdown ms-lg-1">
							<div class="btn-group">
								<a href="#" class="btn btn-flat-indigo border-transparent btn-sm dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
									<i class="ph-gear me-1"></i>
									<span style="font-size:0.8rem;">Azioni Multiple</span>
								</a>
								<div class="dropdown-menu dropdown-menu-end">
									<div class="dropdown-submenu dropdown-submenu-start">
										<a href="#" class="dropdown-item">
											<i class="far fa-ballot-check fa-fw me-2"></i><span class="text-muted me-1">|</span>Stato
										</a>
										<div class="dropdown-menu">
											<a href="#" class="dropdown-item" v-if="$root.hasFunzionalita('VOCI_PREFERITE_UPDATE')" @click.prevent="attivaSelezionati()">
												<i class="far fa-check-square fa-fw me-2"></i>Attiva selezionati
											</a>
											<a href="#" class="dropdown-item" v-if="$root.hasFunzionalita('VOCI_PREFERITE_UPDATE')" @click.prevent="disattivaSelezionati()">
												<i class="far fa-square fa-fw me-2"></i>Disattiva selezionati
											</a>
										</div>
									</div>
									<div class="dropdown-submenu dropdown-submenu-start" v-if="$root.hasFunzionalita('VOCI_PREFERITE_EXPORT')">
										<a href="#" class="dropdown-item">
											<i class="far fa-file-export fa-fw me-2"></i>
											<span class="text-muted me-1">|</span>Esporta dati
										</a>
										<div class="dropdown-menu">
											<a href="#" class="dropdown-item" @click.prevent="apriEsportazione('pagina')">
												<i class="far fa-file-export fa-fw me-2"></i>Pagina corrente
											</a>
											<a href="#" class="dropdown-item" @click.prevent="apriEsportazione('selezionati')">
												<i class="far fa-file-export fa-fw me-2"></i>Voci selezionate
											</a>
											<a href="#" class="dropdown-item" @click.prevent="apriEsportazione('tutti')">
												<i class="far fa-file-export fa-fw me-2"></i>Tutte le voci
											</a>
										</div>
									</div>
									<div class="dropdown-divider"></div>
									<a href="#" class="dropdown-item" v-if="$root.hasFunzionalita('VOCI_PREFERITE_DELETE')" @click.prevent="eliminaSelezionati()">
										<i class="far fa-trash fa-fw me-2 text-danger"></i>
										<span class="text-muted me-1">|</span>Elimina selezionati
									</a>
									<a href="#" class="dropdown-item" @click.prevent="eliminaDefinitivamenteSelezionati()" v-if="$root.isGod">
										<i class="far fa-trash-alt fa-fw me-2 text-danger"></i>
										<span class="text-muted me-1">|</span>Elimina definitivamente selezionati
									</a>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
	<!-- /Page Header -->

	<div class="content content-1 table-cms-wrapper">
		<div class="tab-content flex-1 order-2 order-lg-1">
			<div class="tab-pane fade active show" id="vocip-tab">

	<div class="card shadow mb-xs-3 mb-lg-0">
		<div class="card-body pb-0">
			<div class="alert alert-2 alert-secondary border-0">
				<div class="row">
					<div class="col-md-4 mbx-1">
						<input autocomplete="off" class="form-control form-control-sm" type="text"
							placeholder="Cerca titolo..." v-model="searchVociPreferite.TITOLO.VALUE" />
					</div>
					<div class="col-md-2 mbx-1" v-if="$root.isGod">
						<select class="form-select form-select-sm" v-model="searchVociPreferite.FLG_ATTIVO.VALUE">
							<option value="">Tutti</option>
							<option value="1">Attive</option>
							<option value="0">Disattivate</option>
						</select>
					</div>
					<div class="col-md-2 mbx-1" v-if="$root.isGod">
						<select class="form-select form-select-sm" v-model="searchVociPreferite.FLG_ELIMINATO.VALUE">
							<option value="0">Non eliminate</option>
							<option value="">Tutte</option>
							<option value="1">Eliminate</option>
						</select>
					</div>
				</div>
			</div>
		</div>

		<div class="card-body box-card mt-0 mb-0">
			<div class="div_table_resp tableFixHead">
				<table class="table table-bordered table-hover table-striped text-nowrap">
					<thead class="sticky-top thead-bordered">
						<tr class="bg-secondary text-white">
							<th class="table-head-sm text-center" style="width:3%;" rowspan="2">
								<input id="chkAllVociPreferite" type="checkbox"
									v-on:click="filters.selectAll('chkAllVociPreferite', paginatedListVociPreferite.arr)">
							</th>
							<th class="table-head-sm text-center" style="width:3%;" rowspan="2">#</th>
							<th class="table-head-sm text-center bg-secondary bg-opacity-75" :style="$root.isGod ? 'width:47%;' : 'width:50%;'" colspan="6">VENDITA</th>
							
							<th class="table-head-sm text-center bg-secondary bg-opacity-75 text-yellow" :style="$root.isGod ? 'width:29%;' : 'width:32%;'" colspan="4">ACQUISTO</th>
							<th v-if="$root.isGod" class="table-head-sm text-center" style="width:4%;" rowspan="2">Attivo</th>
							<th class="table-head-sm text-center" style="width:10%;" rowspan="2">Azioni</th>
						</tr>
						<tr class="bg-secondary text-white">
							<th class="table-head-sm" style="width:18%;">Titolo<ISort class="float-end" v-model="ordinamento" :campo="'TITOLO'"></ISort></th>
							<th class="table-head-sm text-center" style="width:6%;">Q.tà<ISort class="float-end" v-model="ordinamento" :campo="'QUANTITY_PRICE'"></ISort></th>
							<th class="table-head-sm text-center" style="width:6%;">Rip.<ISort class="float-end" v-model="ordinamento" :campo="'DAYS_PRICE'"></ISort></th>
							<th class="table-head-sm text-end" style="width:8%;">Prezzo Unit.<ISort class="float-end" v-model="ordinamento" :campo="'UNIT_PRICE'"></ISort></th>
							<th class="table-head-sm text-end" style="width:9%;">Totale<ISort class="float-end" v-model="ordinamento" :campo="'TOTAL_PRICE'"></ISort></th>
						<th class="table-head-sm" style="width:8%;">Cliente<ISort class="float-end" v-model="ordinamento" :campo="'AZIENDA'"></ISort></th>
							<th class="table-head-sm text-end text-yellow" style="width:8%;">Costo Unit.<ISort class="float-end" v-model="ordinamento" :campo="'UNIT_COST_ESPOSTO'"></ISort></th>
							<th class="table-head-sm text-end text-yellow" style="width:9%;">Costi<ISort class="float-end" v-model="ordinamento" :campo="'TOTAL_COST_ESPOSTO'"></ISort></th>
							<th class="table-head-sm text-end text-yellow" style="width:9%;">Commissioni<ISort class="float-end" v-model="ordinamento" :campo="'UNIT_COST_PRIVATO'"></ISort></th>
							<th class="table-head-sm text-yellow" style="width:10%;">Fornitore<ISort class="float-end" v-model="ordinamento" :campo="'AZIENDA_FORNITORE'"></ISort></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(vp, index) in paginatedListVociPreferite.arr" :key="vp.ID_VOCE_PREFERITA"
							:class="{ 'table-secondary text-muted': vp.FLG_ATTIVO == 0, 'table-danger text-muted': vp.FLG_ELIMINATO == 1 }">
							<td class="table-head-sm text-center">
								<input type="checkbox"
									v-bind:true-value="1"
									v-bind:false-value="0"
									v-model="vp.SELEZIONATO" />
							</td>
							<td class="table-head-sm text-center"><small>{{ index + 1 }}</small></td>
							<td class="table-head-sm" style="word-wrap: break-word; white-space: normal;">
								<i class="ph-file-text me-1 text-muted"></i><strong>{{ vp.TITOLO }}</strong>
								<div v-if="vp.TESTO_NOTE" class="text-muted small">{{ vp.TESTO_NOTE }}</div>
							</td>
							<td class="table-head-sm text-end">{{ parseFloat(vp.QUANTITY_PRICE) }}</td>
							<td class="table-head-sm text-end">{{ parseFloat(vp.DAYS_PRICE) }}</td>
							<td class="table-head-sm text-end"><span class="text-muted" style="font-size:0.75rem;">&euro; {{ vp.UNIT_PRICE }}</span></td>
							<td class="table-head-sm text-end">
								<span class="text-primary fw-semibold">&euro; {{ vp.TOTAL_PRICE }}</span>
								<span v-if="getIvaCode(vp.FK_ID_IVA_PREZZO)"
									class="badge bg-secondary ms-1"
									style="font-size:0.65rem;"
									:title="getIvaCode(vp.FK_ID_IVA_PREZZO).DESCRIZIONE">
									{{ getIvaCode(vp.FK_ID_IVA_PREZZO).CUSTOM_1 }}
								</span>
							</td>
							<td class="table-head-sm">
								<span v-if="vp.AZIENDA" class="text-muted" style="font-size:0.75rem;">{{ filters.accorciaTesto(vp.AZIENDA, 30) }}</span>
								<span v-else class="text-muted fst-italic" style="font-size:0.7rem;">-</span>
							</td>
							<td class="table-head-sm text-end"><span class="text-muted" style="font-size:0.75rem;">&euro; {{ vp.UNIT_COST_ESPOSTO }}</span></td>
							<td class="table-head-sm text-end">
								<span class="text-danger fw-semibold">&euro; {{ vp.TOTAL_COST_ESPOSTO }}</span>
								<span v-if="getIvaCode(vp.FK_ID_IVA_COSTO)"
									class="badge bg-secondary ms-1"
									style="font-size:0.65rem;"
									:title="getIvaCode(vp.FK_ID_IVA_COSTO).DESCRIZIONE">
									{{ getIvaCode(vp.FK_ID_IVA_COSTO).CUSTOM_1 }}
								</span>
							</td>
							<td class="table-head-sm text-end">
								<span class="text-warning" style="font-size:0.75rem;">&euro; {{ parseFloat(vp.UNIT_COST_PRIVATO).toFixed(2) }}</span>
								<span v-if="getIvaCode(vp.FK_ID_IVA_COMMISSIONI)"
									class="badge bg-secondary ms-1"
									style="font-size:0.65rem;"
									:title="getIvaCode(vp.FK_ID_IVA_COMMISSIONI).DESCRIZIONE">
									{{ getIvaCode(vp.FK_ID_IVA_COMMISSIONI).CUSTOM_1 }}
								</span>
							</td>
							<td class="table-head-sm">
								<span v-if="vp.AZIENDA_FORNITORE" class="text-muted" style="font-size:0.75rem;">{{ filters.accorciaTesto(vp.AZIENDA_FORNITORE, 30) }}</span>
								<span v-else class="text-muted fst-italic" style="font-size:0.7rem;">-</span>
							</td>
							<td v-if="$root.isGod" class="table-head-sm text-center">
								<ISwitch
									:size="'xs'"
									:modelValue="vp.FLG_ATTIVO"
									@toggle="(val) => toggleFlgAttivo(vp, val)"
									title="Attivo/Disattivo"
								></ISwitch>
							</td>
							<td class="table-head-sm text-center">
								<div class="dropdown">
									<a href="#" class="text-body" data-bs-toggle="dropdown">
										<i class="ph-list"></i>
									</a>
									<div class="dropdown-menu dropdown-menu-end">
										<a href="#" class="dropdown-item" @click="modificaVocePreferita(vp)" v-if="vp.FLG_ELIMINATO != 1 && $root.hasFunzionalita('VOCI_PREFERITE_UPDATE')">
											<i class="ph-pencil me-2"></i>Modifica
										</a>
										<a href="#" class="dropdown-item" @click="eliminaVocePreferita(vp)" v-if="vp.FLG_ELIMINATO != 1 && $root.hasFunzionalita('VOCI_PREFERITE_DELETE')">
											<i class="ph-trash text-danger me-2"></i>Elimina
										</a>
										<a href="#" class="dropdown-item" @click.prevent="eliminaDefinitivamenteVocePreferita(vp)" v-if="$root.isGod && vp.FLG_ELIMINATO == 1">
											<i class="ph-trash-simple text-danger me-2"></i>Elimina definitivamente
										</a>
										<a href="#" class="dropdown-item" @click.prevent="ripristinaVocePreferita(vp)" v-if="$root.isGod && vp.FLG_ELIMINATO == 1">
											<i class="ph-arrow-counter-clockwise text-success me-2"></i>Ripristina
										</a>
									</div>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div class="row page-bottom">
				<div class="col-12 col-md-5 d-none d-sm-block">
					<div style="position: relative; top: 10px;">
						<span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2">VOCI
							PREFERITE: {{ paginatedListVociPreferite.count }}</span>
					</div>
				</div>
				<div class="col-9 col-md-6">
					<div class="float-end pag-mobile">
						<Pagine v-model="searchVociPreferite.PAGINATION.PAGE_NUMBER"
							:numrighe="paginatedListVociPreferite.count"
							:numpagine="searchVociPreferite.PAGINATION.LENGTH" :modalita="$root.isMobile ? 2 : 1"></Pagine>
					</div>
				</div>
				<div class="col-3 col-md-1">
					<select class="form-select form-select-sm wmin-100 mt-2 float-end"
						data-placeholder="Limite" :tabindex="20"
						v-model="searchVociPreferite.PAGINATION.PAGE_SIZE"
						style="position: relative; top: 0px; padding: 0.4375rem 0.5rem;">
						<option value="5">5</option>
						<option value="10">10</option>
						<option value="25">25</option>
						<option value="50">50</option>
						<option value="75">75</option>
						<option value="100">100</option>
						<option value="250">250</option>
						<option value="500">500</option>
					</select>
				</div>
			</div>
		</div>
	</div>

			</div><!-- /tab-pane -->
		</div><!-- /tab-content -->
	</div><!-- /content -->

	<!-- Modale Voce Preferita -->
	<div class="modal fade" :id="'popUpVocePreferita' + rs" role="dialog" data-bs-backdrop="static">
		<div class="modal-dialog modal-xl">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white border-0 py-2">
					<h6 class="modal-title mb-0">
						<i class="ph-plus-circle me-2"></i>
						{{ vocePreferitaSelezionata.ID_VOCE_PREFERITA > 0 ? 'Modifica' : 'Nuova' }} Voce Preferita
					</h6>
					<button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill" data-bs-dismiss="modal"><i class="ph-x icon-x-size"></i></button>
				</div>
				<div class="modal-body p-3">
					<div class="row mb-2">
						<div class="col-md-6">
							<label class="form-label fw-semibold mb-1">Titolo <span class="text-danger">*</span></label>
							<textarea class="form-control form-control-sm" v-model="vocePreferitaSelezionata.TITOLO"
								rows="7" placeholder="Es: Noleggio auto..." style="resize: vertical;"></textarea>
						</div>
						<div class="col-md-6">
							<div class="mb-2">
								<label class="form-label fw-semibold mb-1">Note</label>
								<input type="text" class="form-control form-control-sm" v-model="vocePreferitaSelezionata.TESTO_NOTE"
									placeholder="Inserisci eventuali note">
							</div>
							<div class="mb-2">
								<label class="form-label fw-semibold mb-1">Cliente</label>
								<Select2 v-model="vocePreferitaSelezionata.FK_ID_AZIENDA" :api="'theb-s2/agenzie'"
									:apiselected="'theb-s2/agenzie/selected?a=1'"></Select2>
							</div>
							<div>
								<label class="form-label fw-semibold mb-1">Fornitore</label>
								<Select2 v-model="vocePreferitaSelezionata.FK_ID_AZIENDA_FORNITORE"
									:api="'theb-s2/fornitori'"
									:apiselected="'theb-s2/fornitori/selected'"></Select2>
							</div>
						</div>
					</div>

					<h6 class="fw-semibold text-primary mb-1 mt-2"><i class="ph-currency-circle-dollar me-1"></i>Vendita al cliente</h6>
					<div class="row mb-2">
						<div class="col">
							<label class="form-label mb-1" style="font-size:0.85rem;">Qtà</label>
							<input type="number" step="1" min="1" class="form-control form-control-sm"
								v-model.number="vocePreferitaSelezionata.QUANTITY_PRICE" placeholder="1"
								@input="calcolaTotaliVocePreferita()"
								@keypress="(e) => { if(e.key == '.' || e.key == ',') e.preventDefault(); }">
						</div>
						<div class="col">
							<label class="form-label mb-1" style="font-size:0.85rem;">Rip.</label>
							<input type="number" step="1" min="1" class="form-control form-control-sm"
								v-model.number="vocePreferitaSelezionata.DAYS_PRICE" placeholder="1"
								@input="calcolaTotaliVocePreferita()"
								@keypress="(e) => { if(e.key == '.' || e.key == ',') e.preventDefault(); }">
						</div>
						<div class="col">
							<label class="form-label fw-semibold mb-1" style="width:100%; font-size:0.85rem;">Prezzo Unit.
								<span class="badge badge-xs cursor-pointer float-end"
									:class="vocePreferitaSelezionata.FLG_OMAGGIO_UNIT_PRICE == 1 ? 'bg-success' : 'bg-secondary'"
									@click="toggleOmaggio('UNIT_PRICE')"
									:title="vocePreferitaSelezionata.FLG_OMAGGIO_UNIT_PRICE == 1 ? 'Clicca per disattivare omaggio' : 'Clicca per impostare come omaggio'"
								>omaggio</span>
							</label>
							<input type="number" step="0.01" class="form-control form-control-sm"
								v-model="vocePreferitaSelezionata.UNIT_PRICE" placeholder="0.00"
								:disabled="vocePreferitaSelezionata.FLG_OMAGGIO_UNIT_PRICE == 1"
								@input="calcolaTotaliVocePreferita()"
								@blur="vocePreferitaSelezionata.UNIT_PRICE = parseFloat(vocePreferitaSelezionata.UNIT_PRICE || 0).toFixed(2)">
						</div>
						<div class="col">
							<label class="form-label mb-1" style="font-size:0.85rem;">IVA</label>
							<select class="form-select form-select-sm" v-model="vocePreferitaSelezionata.FK_ID_IVA_PREZZO">
								<option :value="null">— Nessuna —</option>
								<option v-for="c in filters.getCodiciIvaAttivi()" :key="c.ID_OPZIONE_TIPOLOGICA" :value="c.ID_OPZIONE_TIPOLOGICA">
									{{ c.CUSTOM_1 }} – {{ c.DESCRIZIONE }}
								</option>
							</select>
						</div>
						<div class="col">
							<label class="form-label fw-semibold mb-1" style="width:100%; font-size:0.85rem;">Tot. Vendita</label>
							<input type="text" class="form-control form-control-sm bg-light text-primary fw-bold"
								:value="vocePreferitaSelezionata.TOTAL_PRICE" readonly>
						</div>
						<template v-if="ivaModaleSommario.importo > 0">
							<div class="col">
								<label class="form-label mb-1" style="font-size:0.85rem;">IVA ({{ ivaModaleSommario.aliquota }}%)</label>
								<input type="text" class="form-control form-control-sm" readonly :value="ivaModaleSommario.importo">
							</div>
							<div class="col">
								<label class="form-label mb-1" style="font-size:0.85rem;">Totale con IVA</label>
								<input type="text" class="form-control form-control-sm bg-light" readonly :value="ivaModaleSommario.totale">
							</div>
						</template>
					</div>

					<h6 class="fw-semibold text-danger mb-1 mt-2"><i class="ph-shopping-cart me-1"></i>Costo d'Acquisto</h6>
					<div class="row mb-2">
						<div class="col">
							<label class="form-label mb-1" style="font-size:0.85rem;">Qtà</label>
							<input type="number" step="1" min="1" class="form-control form-control-sm"
								v-model.number="vocePreferitaSelezionata.QUANTITY_COST_ESPOSTO" placeholder="1"
								@input="calcolaTotaliVocePreferita()"
								@keypress="(e) => { if(e.key == '.' || e.key == ',') e.preventDefault(); }">
						</div>
						<div class="col">
							<label class="form-label mb-1" style="font-size:0.85rem;">Rip.</label>
							<input type="number" step="1" min="1" class="form-control form-control-sm"
								v-model.number="vocePreferitaSelezionata.DAYS_COST_ESPOSTO" placeholder="1"
								@input="calcolaTotaliVocePreferita()"
								@keypress="(e) => { if(e.key == '.' || e.key == ',') e.preventDefault(); }">
						</div>
						<div class="col">
							<label class="form-label fw-semibold mb-1" style="width:100%; font-size:0.85rem;">Costo Acq.
								<span class="badge badge-xs cursor-pointer float-end"
									:class="vocePreferitaSelezionata.FLG_OMAGGIO_UNIT_COST_ESPOSTO == 1 ? 'bg-success' : 'bg-secondary'"
									@click="toggleOmaggio('UNIT_COST_ESPOSTO')"
									:title="vocePreferitaSelezionata.FLG_OMAGGIO_UNIT_COST_ESPOSTO == 1 ? 'Clicca per disattivare omaggio' : 'Clicca per impostare come omaggio'"
								>omaggio</span>
							</label>
							<input type="number" step="0.01" class="form-control form-control-sm"
								v-model="vocePreferitaSelezionata.UNIT_COST_ESPOSTO" placeholder="0.00"
								:disabled="vocePreferitaSelezionata.FLG_OMAGGIO_UNIT_COST_ESPOSTO == 1"
								@input="calcolaTotaliVocePreferita()"
								@blur="vocePreferitaSelezionata.UNIT_COST_ESPOSTO = parseFloat(vocePreferitaSelezionata.UNIT_COST_ESPOSTO || 0).toFixed(2)">
						</div>
						<div class="col">
							<label class="form-label mb-1" style="font-size:0.85rem;">IVA Acquisto</label>
							<select class="form-select form-select-sm" v-model="vocePreferitaSelezionata.FK_ID_IVA_COSTO">
								<option :value="null">— Nessuna —</option>
								<option v-for="c in filters.getCodiciIvaAttivi()" :key="c.ID_OPZIONE_TIPOLOGICA" :value="c.ID_OPZIONE_TIPOLOGICA">
									{{ c.CUSTOM_1 }} – {{ c.DESCRIZIONE }}
								</option>
							</select>
						</div>
						<div class="col">
							<label class="form-label mb-1" style="font-size:0.85rem;">Tot. Acquisto</label>
							<input type="text" class="form-control form-control-sm bg-light text-danger fw-bold"
								:value="vocePreferitaSelezionata.TOTAL_COST_ESPOSTO" readonly>
						</div>
						<template v-if="ivaAcquistoSommario.importo > 0">
							<div class="col">
								<label class="form-label mb-1" style="font-size:0.85rem;">IVA Acq. ({{ ivaAcquistoSommario.aliquota }}%)</label>
								<input type="text" class="form-control form-control-sm" readonly :value="ivaAcquistoSommario.importo">
							</div>
							<div class="col">
								<label class="form-label mb-1" style="font-size:0.85rem;">Totale Acq. con IVA</label>
								<input type="text" class="form-control form-control-sm bg-light" readonly :value="ivaAcquistoSommario.totale">
							</div>
						</template>
					</div>

					<h6 class="fw-semibold text-warning mb-1 mt-2"><i class="ph-handshake me-1"></i>Commissioni</h6>
					<div class="row">
						<div class="col">
							<label class="form-label mb-1" style="font-size:0.85rem;">Commissioni</label>
							<input type="number" step="0.01" class="form-control form-control-sm"
								v-model="vocePreferitaSelezionata.UNIT_COST_PRIVATO" placeholder="0.00"
								@blur="vocePreferitaSelezionata.UNIT_COST_PRIVATO = parseFloat(vocePreferitaSelezionata.UNIT_COST_PRIVATO || 0).toFixed(2)">
						</div>
						<div class="col">
							<label class="form-label mb-1" style="font-size:0.85rem;">IVA Commissioni</label>
							<select class="form-select form-select-sm" v-model="vocePreferitaSelezionata.FK_ID_IVA_COMMISSIONI">
								<option :value="null">— Nessuna —</option>
								<option v-for="c in filters.getCodiciIvaAttivi()" :key="c.ID_OPZIONE_TIPOLOGICA" :value="c.ID_OPZIONE_TIPOLOGICA">
									{{ c.CUSTOM_1 }} – {{ c.DESCRIZIONE }}
								</option>
							</select>
						</div>
						<div class="col">
							<label class="form-label fw-semibold mb-1" style="width:100%; font-size:0.85rem;">Totale Commissioni
								<span class="badge badge-xs cursor-pointer float-end"
									:class="vocePreferitaSelezionata.FLG_OMAGGIO_TOTAL_COST_PRIVATO == 1 ? 'bg-success' : 'bg-secondary'"
									@click="toggleOmaggio('TOTAL_COST_PRIVATO')"
									:title="vocePreferitaSelezionata.FLG_OMAGGIO_TOTAL_COST_PRIVATO == 1 ? 'Clicca per disattivare omaggio' : 'Clicca per impostare come omaggio'"
								>omaggio</span>
							</label>
							<input type="number" step="0.01" class="form-control form-control-sm"
								v-model="vocePreferitaSelezionata.TOTAL_COST_PRIVATO" placeholder="0.00"
								:disabled="vocePreferitaSelezionata.FLG_OMAGGIO_TOTAL_COST_PRIVATO == 1"
								@blur="vocePreferitaSelezionata.TOTAL_COST_PRIVATO = parseFloat(vocePreferitaSelezionata.TOTAL_COST_PRIVATO || 0).toFixed(2)">
						</div>
						<template v-if="ivaCommissioniSommario.importo > 0">
							<div class="col">
								<label class="form-label mb-1" style="font-size:0.85rem;">IVA Comm. ({{ ivaCommissioniSommario.aliquota }}%)</label>
								<input type="text" class="form-control form-control-sm" readonly :value="ivaCommissioniSommario.importo">
							</div>
							<div class="col">
								<label class="form-label mb-1" style="font-size:0.85rem;">Totale Comm. con IVA</label>
								<input type="text" class="form-control form-control-sm bg-light" readonly :value="ivaCommissioniSommario.totale">
							</div>
						</template>
					</div>
				</div>
				<div class="modal-footer py-2">
					<button type="button" class="btn btn-sm btn-link" data-bs-dismiss="modal">Annulla</button>
					<button type="button" class="btn btn-sm btn-secondary" @click="salvaVocePreferita()"
						:disabled="!vocePreferitaSelezionata.TITOLO">
						<i class="ph-check me-1"></i>Salva e chiudi
					</button>
					<button v-if="vocePreferitaSelezionata.ID_VOCE_PREFERITA === 0" type="button" class="btn btn-sm btn-primary" @click="salvaVocePreferita(true)"
						:disabled="!vocePreferitaSelezionata.TITOLO">
						<i class="ph-check me-1"></i>Salva e continua
					</button>
				</div>
			</div>
		</div>
	</div>

	<PopUpEsportazione id="popUpEsportazioneVociPreferite" @esporta="esportaDati" />
</template>

<script>
import Pagine from '@/components/utils/Pagine.vue'
import Select2 from '@/components/utils/Select2.vue'
import ISwitch from '@/components/utils/ISwitch.vue'
import ISort from '@/components/utils/ISort.vue'
import PopUpEsportazione from '@/components/common/PopUpEsportazione.vue'

export default {
	name: "ConfVociPreferiteGenerali",

	components: {
		Pagine,
		Select2,
		ISwitch,
		ISort,
		PopUpEsportazione
	},

	data: function () {
		return {
			filters: global.filters,
			rs: utils.generateRandomString(30),
			esportazioneTipo: '',
			arrayVociPreferite: new Array(),
			vocePreferitaSelezionata: {},
			searchVociPreferite: {
				PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 25 },
				TITOLO: { TYPE: 'TEXT', VALUE: '' },
				FLG_ATTIVO: { TYPE: 'COMBO', VALUE: '' },
				FLG_ELIMINATO: { TYPE: 'COMBO', VALUE: '0' }
			},
			ordinamento: '',
			omaggioBackup: {}
		}
	},

	methods: {
		getVociPreferite: function () {
			utils.get('theb/voci_preferite/lista', {}, (response) => {
				if (response.esito == 0) {
					this.arrayVociPreferite = response.data || [];
					// Emetti evento al parent per aggiornare i suoi dati
					this.$emit('update:vociPreferite', this.arrayVociPreferite);
				}
			});
		},

		nuovaVocePreferita: function () {
			this.vocePreferitaSelezionata = {
				ID_VOCE_PREFERITA: 0,
				FK_ID_UTENTE: this.$root.utente.ID_UTENTE,
				FK_ID_AZIENDA: null,
				FK_ID_AZIENDA_FORNITORE: null,
				TITOLO: '',
				TESTO_NOTE: '',
				QUANTITY_PRICE: 1,
				DAYS_PRICE: 1,
				QUANTITY_COST_ESPOSTO: 1,
				DAYS_COST_ESPOSTO: 1,
				UNIT_PRICE: 0,
				TOTAL_PRICE: 0,
				UNIT_COST_ESPOSTO: 0,
				TOTAL_COST_ESPOSTO: 0,
				UNIT_COST_PRIVATO: 0,
				TOTAL_COST_PRIVATO: 0,
				FK_ID_IVA_PREZZO: null,
				FK_ID_IVA_COSTO: null,
				FK_ID_IVA_COMMISSIONI: null,
				FLG_OMAGGIO_UNIT_PRICE: 0,
				FLG_OMAGGIO_UNIT_COST_ESPOSTO: 0,
				FLG_OMAGGIO_TOTAL_COST_PRIVATO: 0,
				FLG_PUBBLICO: 0,
				FLG_ATTIVO: 1,
				ORDINE: 0
			};
			this.filters.openPopUp('popUpVocePreferita' + this.rs);
		},

		modificaVocePreferita: function (vp) {
			this.vocePreferitaSelezionata = utils.clone(vp);
			this.filters.openPopUp('popUpVocePreferita' + this.rs);
		},

		attivaSelezionati() {
			var sel = utils.array.select(this.arrayVociPreferite, 'SELEZIONATO', 1);
			if (sel.length == 0) { utils.alert.warning('Nessuna voce preferita selezionata.'); return; }
			utils.alert.confirm('Attivare ' + sel.length + ' voci preferite?', () => {
				utils.put('theb/voci_preferite/attiva-bulk', { IDS: sel.map(v => v.ID_VOCE_PREFERITA) }, (r) => {
					if (r.esito == 0) { this.getVociPreferite(); utils.alert.success('Voci preferite attivate con successo.'); }
				});
			}, this.$root);
		},
		disattivaSelezionati() {
			var sel = utils.array.select(this.arrayVociPreferite, 'SELEZIONATO', 1);
			if (sel.length == 0) { utils.alert.warning('Nessuna voce preferita selezionata.'); return; }
			utils.alert.confirm('Disattivare ' + sel.length + ' voci preferite?', () => {
				utils.put('theb/voci_preferite/disattiva-bulk', { IDS: sel.map(v => v.ID_VOCE_PREFERITA) }, (r) => {
					if (r.esito == 0) { this.getVociPreferite(); utils.alert.success('Voci preferite disattivate con successo.'); }
				});
			}, this.$root);
		},
		eliminaSelezionati() {
			var sel = utils.array.select(this.arrayVociPreferite, 'SELEZIONATO', 1);
			if (sel.length == 0) { utils.alert.warning('Nessuna voce preferita selezionata.'); return; }
			utils.alert.confirm('Eliminare ' + sel.length + ' voci preferite selezionate?', () => {
				utils.delete('theb/voci_preferite/delete-bulk', { IDS: sel.map(v => v.ID_VOCE_PREFERITA) }, (r) => {
					if (r.esito == 0) { this.getVociPreferite(); utils.alert.success('Voci preferite eliminate con successo.'); }
				});
			}, this.$root);
		},
		eliminaDefinitivamenteSelezionati() {
			var sel = utils.array.select(this.arrayVociPreferite, 'SELEZIONATO', 1);
			if (sel.length == 0) { utils.alert.warning('Nessuna voce preferita selezionata.'); return; }
			utils.alert.confirm('Eliminare DEFINITIVAMENTE ' + sel.length + ' voci preferite? Azione irreversibile.', () => {
				utils.delete('theb/voci_preferite/harddelete-bulk', { IDS: sel.map(v => v.ID_VOCE_PREFERITA) }, (r) => {
					if (r.esito == 0) { this.getVociPreferite(); utils.alert.success('Voci preferite eliminate definitivamente.'); }
				});
			}, this.$root);
		},
		ripristinaVocePreferita(vp) {
			utils.put('theb/voci_preferite/ripristina', { ID_VOCE_PREFERITA: vp.ID_VOCE_PREFERITA }, (r) => {
				if (r.esito == 0) {
					this.getVociPreferite();
					utils.alert.success('Voce preferita ripristinata con successo.');
					utils.notifiche.invia(this, 'VOCE_PREFERITA_MODIFICA', 'ha ripristinato la voce preferita "' + vp.TITOLO + '"');
				}
			});
		},
		eliminaVocePreferita(vp) {
			utils.alert.confirm(`Eliminare la voce preferita "${vp.TITOLO}"?`, () => {
				utils.delete('theb/voci_preferite/delete', { ID_VOCE_PREFERITA: vp.ID_VOCE_PREFERITA }, (r) => {
					if (r.esito == 0) {
						this.getVociPreferite();
						utils.alert.success('Voce preferita eliminata con successo.');
						utils.notifiche.invia(this, 'VOCE_PREFERITA_ELIMINA', 'ha eliminato la voce preferita "' + vp.TITOLO + '"');
					}
				});
			}, this.$root);
		},
		eliminaDefinitivamenteVocePreferita(vp) {
			utils.alert.confirm(`Eliminare DEFINITIVAMENTE "${vp.TITOLO}"? Azione irreversibile.`, () => {
				utils.delete('theb/voci_preferite/harddelete', { ID_VOCE_PREFERITA: vp.ID_VOCE_PREFERITA }, (r) => {
					if (r.esito == 0) {
						this.getVociPreferite();
						utils.alert.success('Voce preferita eliminata definitivamente.');
					}
				});
			}, this.$root);
		},

		toggleFlgAttivo: function (vp, newValue) {
			utils.put('theb/voci_preferite/update', {
				ID_VOCE_PREFERITA: vp.ID_VOCE_PREFERITA,
				FLG_ATTIVO: newValue
			}, (response) => {
				if (response.esito == 0) {
					this.getVociPreferite();
				}
			});
		},

		salvaVocePreferita: function (continua = false) {
			if (!this.vocePreferitaSelezionata.TITOLO) {
				utils.alert.warning('Il titolo è obbligatorio');
				return;
			}
			this.calcolaTotaliVocePreferita();
			const isUpdate = this.vocePreferitaSelezionata.ID_VOCE_PREFERITA > 0;
			const endpoint = isUpdate ? 'theb/voci_preferite/update' : 'theb/voci_preferite/insert';
			(isUpdate ? utils.put : utils.post)(endpoint, this.vocePreferitaSelezionata, (response) => {
				if (response.esito == 0) {
					this.getVociPreferite();
					utils.alert.success('Voce preferita salvata con successo!');
					utils.notifiche.invia(this, endpoint.includes('insert') ? 'VOCE_PREFERITA_CREA' : 'VOCE_PREFERITA_MODIFICA', (endpoint.includes('insert') ? 'ha creato la voce preferita "' : 'ha modificato la voce preferita "') + this.vocePreferitaSelezionata.TITOLO + '"');
					if (continua) {
						this.vocePreferitaSelezionata = {
							ID_VOCE_PREFERITA: 0,
							FK_ID_UTENTE: this.$root.utente.ID_UTENTE,
							FK_ID_AZIENDA: null,
							FK_ID_AZIENDA_FORNITORE: null,
							TITOLO: '',
							TESTO_NOTE: '',
							QUANTITY_PRICE: 1,
							DAYS_PRICE: 1,
							QUANTITY_COST_ESPOSTO: 1,
							DAYS_COST_ESPOSTO: 1,
							UNIT_PRICE: 0,
							TOTAL_PRICE: 0,
							UNIT_COST_ESPOSTO: 0,
							TOTAL_COST_ESPOSTO: 0,
							UNIT_COST_PRIVATO: 0,
							TOTAL_COST_PRIVATO: 0,
							FK_ID_IVA_PREZZO: null,
							FK_ID_IVA_COSTO: null,
							FK_ID_IVA_COMMISSIONI: null,
							FLG_OMAGGIO_UNIT_PRICE: 0,
							FLG_OMAGGIO_UNIT_COST_ESPOSTO: 0,
							FLG_OMAGGIO_TOTAL_COST_PRIVATO: 0,
							FLG_PUBBLICO: 0,
							FLG_ATTIVO: 1,
							ORDINE: 0
						};
					} else {
						this.filters.closePopUp('popUpVocePreferita' + this.rs);
					}
				} else {
					utils.alert.warning('Errore: ' + response.messaggio);
				}
			});
		},

		apriEsportazione: function(tipo) {
			this.esportazioneTipo = tipo;
			this.filters.openPopUp('popUpEsportazioneVociPreferite');
		},

		esportaDati: function(formato) {
			utils.esportaTabella({
				tipo:          this.esportazioneTipo,
				formato:       formato,
				arrayCompleto: this.arrayVociPreferite,
				arrayPagina:   this.paginatedListVociPreferite.arr,
				idField:       'ID_VOCE_PREFERITA',
				modulo:        'vociPreferite',
				nomeFile:      'voci_preferite'
			});
		},

		toggleOmaggio: function(field) {
			const flagField = `FLG_OMAGGIO_${field}`;
			const isOmaggio = this.vocePreferitaSelezionata[flagField] == 1;
			this.vocePreferitaSelezionata[flagField] = isOmaggio ? 0 : 1;

			if (!isOmaggio) {
				this.omaggioBackup[field] = this.vocePreferitaSelezionata[field];
				this.vocePreferitaSelezionata[field] = 0;
			} else {
				this.vocePreferitaSelezionata[field] = this.omaggioBackup[field] ?? 0;
			}
			this.calcolaTotaliVocePreferita();
		},

		getIvaCode(fkId) {
			return (this.$root.arrayCodiciIva || []).find(c => c.ID_OPZIONE_TIPOLOGICA == fkId) || null;
		},

		parseCodiceIva: function(codiceIva) {
			if (!codiceIva) return { aliquota: 0, tipo: 'nessuna', onHalf: false };
			const custom1 = codiceIva.CUSTOM_1 || '';
			const aliquota = parseFloat(codiceIva.ICONA) || 0;
			const onHalf = custom1.startsWith('i50');
			let tipo = 'nessuna';
			if (aliquota > 0) {
				tipo = (custom1.endsWith('i') || custom1 === 'IN') ? 'inclusa'
					 : custom1.endsWith('e') ? 'esclusa'
					 : 'nessuna';
			}
			return { aliquota, tipo, onHalf };
		},

		calcolaImportoIva: function(prezzo, codiceIva) {
			const { aliquota, tipo, onHalf } = this.parseCodiceIva(codiceIva);
			const p = parseFloat(prezzo) || 0;
			if (tipo === 'nessuna') return 0;
			const base = onHalf ? p / 2 : p;
			const rate = aliquota / 100;
			return tipo === 'esclusa'
				? base * rate
				: base - base / (1 + rate);
		},

		calcolaTotaliVocePreferita: function () {
			const qPrice = parseFloat(this.vocePreferitaSelezionata.QUANTITY_PRICE) || 0;
			const dPrice = parseFloat(this.vocePreferitaSelezionata.DAYS_PRICE) || 1;
			const qCosto = parseFloat(this.vocePreferitaSelezionata.QUANTITY_COST_ESPOSTO) || 0;
			const dCosto = parseFloat(this.vocePreferitaSelezionata.DAYS_COST_ESPOSTO) || 1;
			this.vocePreferitaSelezionata.TOTAL_PRICE = ((parseFloat(this.vocePreferitaSelezionata.UNIT_PRICE) || 0) * qPrice * dPrice).toFixed(2);
			this.vocePreferitaSelezionata.TOTAL_COST_ESPOSTO = ((parseFloat(this.vocePreferitaSelezionata.UNIT_COST_ESPOSTO) || 0) * qCosto * dCosto).toFixed(2);
		}
	},

	computed: {
		paginatedListVociPreferite() {
			var arr = utils.inGrid(this.arrayVociPreferite, this.searchVociPreferite, this.ordinamento);
			return arr;
		},

		ivaModaleSommario() {
			const codiceIva = (this.$root.arrayCodiciIva || []).find(
				c => c.ID_OPZIONE_TIPOLOGICA == this.vocePreferitaSelezionata.FK_ID_IVA_PREZZO
			);
			const { aliquota, tipo } = this.parseCodiceIva(codiceIva);
			const prezzo = parseFloat(this.vocePreferitaSelezionata.TOTAL_PRICE) || 0;
			const importo = this.calcolaImportoIva(prezzo, codiceIva);
			const totale = tipo === 'esclusa' ? prezzo + importo : prezzo;
			return { aliquota, importo: importo.toFixed(2), totale: totale.toFixed(2) };
		},

		ivaAcquistoSommario() {
			const codiceIva = (this.$root.arrayCodiciIva || []).find(
				c => c.ID_OPZIONE_TIPOLOGICA == this.vocePreferitaSelezionata.FK_ID_IVA_COSTO
			);
			const { aliquota, tipo } = this.parseCodiceIva(codiceIva);
			const prezzo = parseFloat(this.vocePreferitaSelezionata.TOTAL_COST_ESPOSTO) || 0;
			const importo = this.calcolaImportoIva(prezzo, codiceIva);
			const totale = tipo === 'esclusa' ? prezzo + importo : prezzo;
			return { aliquota, importo: importo.toFixed(2), totale: totale.toFixed(2) };
		},

		ivaCommissioniSommario() {
			const codiceIva = (this.$root.arrayCodiciIva || []).find(
				c => c.ID_OPZIONE_TIPOLOGICA == this.vocePreferitaSelezionata.FK_ID_IVA_COMMISSIONI
			);
			const { aliquota, tipo } = this.parseCodiceIva(codiceIva);
			const prezzo = parseFloat(this.vocePreferitaSelezionata.TOTAL_COST_PRIVATO) || 0;
			const importo = this.calcolaImportoIva(prezzo, codiceIva);
			const totale = tipo === 'esclusa' ? prezzo + importo : prezzo;
			return { aliquota, importo: importo.toFixed(2), totale: totale.toFixed(2) };
		}
	},

	mounted: function () {
		this.getVociPreferite();
	},
	
}
</script>

<style scoped>
/* VENDITA: cols 3–8 → off-white lateral borders */
tbody tr td:nth-child(3),
tbody tr td:nth-child(4),
tbody tr td:nth-child(5),
tbody tr td:nth-child(6),
tbody tr td:nth-child(7),
tbody tr td:nth-child(8) {
	border-left: 1px solid #e8e8e8 !important;
	border-right: 1px solid #e8e8e8 !important;
	padding-left: 12px !important;
	padding-right: 12px !important;
}

/* ACQUISTO: cols 9–12 → yellow lateral borders and text color */
tbody tr td:nth-child(9),
tbody tr td:nth-child(10),
tbody tr td:nth-child(11),
tbody tr td:nth-child(12) {
	border-left: 1px solid #FFD648 !important;
	border-right: 1px solid #FFD648 !important;
	padding-left: 12px !important;
	padding-right: 12px !important;
	color: #FFD648 !important;
}

/* Thick border between VENDITA and ACQUISTO - Header */
thead tr:first-child th:nth-child(3) {
	border-right: 20px solid white !important;
}

/* thead tr:first-child th:nth-child(5) {
	border-left: 20px solid white !important;
} */

thead tr:last-child th:nth-child(6) {
	border-right: 20px solid white !important;
}

thead tr:last-child th:nth-child(7) {
	border-left: 20px solid white !important;
}

/* Thick border between VENDITA and ACQUISTO - Body */
tbody tr td:nth-child(8) {
	border-right: 20px solid white !important;
}

tbody tr td:nth-child(9) {
	border-left: 20px solid white !important;
}
</style>
